/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Payment Type
 * @export
 */
export const MemberPaymentMethod = {
    Cash: 'cash',
    Check: 'check',
    CreditCard: 'credit_card',
    Paypal: 'paypal'
} as const;
export type MemberPaymentMethod = typeof MemberPaymentMethod[keyof typeof MemberPaymentMethod];


export function instanceOfMemberPaymentMethod(value: any): boolean {
    for (const key in MemberPaymentMethod) {
        if (Object.prototype.hasOwnProperty.call(MemberPaymentMethod, key)) {
            if (MemberPaymentMethod[key as keyof typeof MemberPaymentMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MemberPaymentMethodFromJSON(json: any): MemberPaymentMethod {
    return MemberPaymentMethodFromJSONTyped(json, false);
}

export function MemberPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberPaymentMethod {
    return json as MemberPaymentMethod;
}

export function MemberPaymentMethodToJSON(value?: MemberPaymentMethod | null): any {
    return value as any;
}

